moya.map = window.moya.map || {};
moya.map = $.extend(moya.map, {
	addTileLayer: function(map, opts) {
		L.tileLayer.wms('https://gis.lmi.is/mapcache/web-mercator/wms?', {
			attribution: '&copy; <a href="https://www.lmi.is" target="_blank">LMÍ</a>',
			layers: 'LMI_Kort',
		}).addTo(map);
		L.tileLayer.wms('https://gis.lmi.is/geoserver/wms?', {
			layers: 'Ornefni',
			transparent: true,
			format: 'image/png',
			version: '1.3.0',
		}).addTo(map);
	},
});
